import React from 'react';
import HELP from '../../src/components/faq/genesys-help';
import PageHead from 'src/components/page-head/page-head.component';
import PageESIWrapper from 'src/components/page-esi-wrapper/page-esi-wrapper.component';
import { GetServerSidePropsContext } from 'next';
import {
  isPreviewMode,
  PageData,
  SSR_STATUS_CODES,
} from 'src/utils/ssr-helper';
import PreviewBannerComponent from 'src/components/preview-banner/preview.banner-component';
import { getPageHeaderData } from 'src/utils/pageheader';

export const getStaticProps = async ({ locale }: GetServerSidePropsContext) => {

    const pageData = {
        status: SSR_STATUS_CODES.SUCCESS,
        errorCode: 0,
        errorMessage: null,
        content: null,
        pageHeader: await getPageHeaderData(
            'Knowledge Portal',
            'Virgin Atlantic - Knowledge Portal',
            'https://virginatlanic.com/help',
            { hideSearchPanel: true },
            new Date().toISOString()
        ),
        localeInfo: locale,
    };
    return {
        props: {
            ...pageData,
        },
        revalidate: 1
    };
};

export const getGenesysPath = (locale: string) => {
  const helpPath = '/help';
  const previewPath = isPreviewMode ? '/preview' : '';
  const localePath = !locale || locale === 'en-GB' ? '' : `/${locale}`;
  return `${previewPath}${localePath}${helpPath}`;
};

const Page = ({ localeInfo, pageHeader }: PageData) => {
  return (
    <div>
      {pageHeader && <PageHead {...pageHeader} />}
      <PageESIWrapper localeInfo={localeInfo}>
        {isPreviewMode && <PreviewBannerComponent />}
        <div style={{ overflow: 'auto', overflowX: 'hidden' }}>
          <HELP path={getGenesysPath(localeInfo)} />
        </div>
      </PageESIWrapper>
    </div>
  );
};

export default Page;